import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const DeleteOrderButton = ({ order }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const nav = useNavigate();
  const go = async () => {
    try {
      await api.post(`/orders/${order.id}/delete`, { reason });
      toast.success(`Ordine ${order.code} eliminato definitivamente`);
      nav("/ordini");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
      <Button variant="destructive" onClick={() => setOpen(true)} className="h-11 rounded-xl font-semibold" data-testid="order-delete-button"><Trash2 className="mr-1 h-4 w-4" />Elimina definitivamente</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-2xl" data-testid="order-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminare definitivamente {order.code}?</AlertDialogTitle>
            <AlertDialogDescription>L'ordine, il suo storico e le foto spariscono dall'app e non si possono recuperare (salvo ripristino da backup). Nel registro audit resta solo la riga firmata dell'eliminazione.</AlertDialogDescription>
          </AlertDialogHeader>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo dell'eliminazione *" data-testid="order-delete-reason" />
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-xl">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={go} disabled={reason.trim().length < 3} className="rounded-xl bg-red-600 hover:bg-red-700" data-testid="order-delete-confirm">Elimina</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
